import logger from "debug";
import { useNuxtApp, useRuntimeConfig } from "#app";
const debug = logger("travvir:debut:store:property");
export const usePropertyStore = defineStore("property", {
  state: () => {
    return {
      map: null,
      google: null,
      property: [],
      hoverPlace: null,
      allMapMarkers: [],
      propertyInfo: null,
      clickedPlace: null,
      leadSubmited: false,
      selectedFile: null,
      isInformationOverlayModalOpen: false,
      associatedFiles: [],
      selectedMapCategory: null,
      mapCategories: [
        {
          value: "restaurant",
          name: "Restaurants",
        },
        {
          value: "shopping_mall",
          name: "Malls",
        },
        {
          value: "subway_station",
          name: "Metro",
        },
        {
          value: "supermarket",
          name: "Market",
        },
        {
          value: "hospital",
          name: "Hospital",
        },
        {
          value: "train_station",
          name: "Railway Stations",
        },
        {
          value: "bus_station",
          name: "Bus Stop",
        },
        {
          value: "airport",
          name: "Airport",
        },
        {
          value: "school",
          name: "School",
        },
        {
          value: "bank",
          name: "Banks",
        },
        {
          value: "place",
          name: "Places",
        },
      ],
    };
  },
  getters: {
    propertyOrigin() {
      if (
        this.propertyInfo.location.latitude &&
        this.propertyInfo.location.longitude
      ) {
        return {
          lat: this.propertyInfo.location.latitude,
          lng: this.propertyInfo.location.longitude,
        };
      }
      return null;
    },
    destinationPlace() {
      if (this.selectedMapPlaces.length && !this.clickedPlace)
        return this.selectedMapPlaces[0];
      return this.selectedMapPlaces.find((p) => p.placeId == this.clickedPlace);
    },
    selectedMapPlaces() {
      return this.propertyInfo.googlePlaces?.filter((place) =>
        place.types.includes(this.selectedMapCategory?.value)
      );
    },
  },
  actions: {
    resetPropertyState() {
      this.propertyInfo = null;
      this.associatedFiles = [];
      this.clickedPlace = null;
      this.leadSubmited = false;
      this.selectedMapCategory = null;
    },
    setSelectedFile(file) {
      this.selectedFile = file;
    },
    setProperties(value) {
      this.property = value;
    },
    setPlaceIsReady(value) {
      this.placeIsReady = value;
    },
    getReady() {
      return new Promise((resolve) => setTimeout(() => resolve(), 4000));
    },
    setLeadSubmited(value) {
      this.leadSubmited = value;
    },
    async getProperty(customId) {
      try {
        if (!customId) {
          console.error("Cannot fetch property: customId is undefined");
          return [];
        }
        if (this.propertyInfo) return;
        try {
          const config = useRuntimeConfig();
          const { data } = await useFetch(
            `${config.public.NUXT_API_URL}/place/${customId}`,
            {
              keys: `public-property-${customId}`,
            }
          );
          if (data && data.value) {
            this.propertyInfo = data.value.data;
            return data.value;
          }
          return [];
        } catch (error) {
          debug(error);
        }
      } catch (error) {
        debug(error);
        return [];
      }
    },
    async getPopertyAssociatedFiles(customId) {
      try {
        if (!customId)
          return console.error("Cannot fetch property: customId is undefined");
        if (this.associatedFiles.length) return;
        const config = useRuntimeConfig();
        const { data } = await useFetch(
          `${config.public.NUXT_API_URL}/place/${customId}/files`,
          {
            keys: `public-property-associated-files-${customId}`,
          }
        );
        if (data && data.value) {
          this.associatedFiles = data.value.data;
          return data.value;
        }
        return [];
      } catch (error) {
        debug(error);
        return [];
      }
    },
    setMapCategory(category) {
      this.selectedMapCategory = category;
    },
    async saveLeadForm({ name, mobile, email, propertyId }) {
      try {
        const config = useRuntimeConfig();
        let response = await $fetch(`${config.public.NUXT_API_URL}/lead`, {
          method: "POST",
          body: {
            name,
            mobile,
            email,
            propertyId,
          },
          onResponseError({ request, response, options }) {
            return { response: null, error: response._data };
          },
        });
        return { response, error: null };
      } catch (error) {
        console.error(error, "Error saving lead form:");
        return { response: null, error };
      }
    },
  },
});
